import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from "rxjs/Observable";
import { Configuration } from '../config/config';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalService {
  public selectedLanguage;
  public selectedLanguageId : string;
  public stepArr : Array<any> = [];
  tourTranslateObj : any;
  socket: any;
  isLoginComm = {
    id: null,
    communityName : null,
    communityID : null,
    purpose : null,
    image_data: null
  };
  private messageSource = new BehaviorSubject<boolean>(false);
  currentMessage = this.messageSource.asObservable();

  constructor(private http:HttpClient, private translate: TranslateService,) {}
  
  changeMessage(message: boolean) {
    this.messageSource.next(message)
  }
  
  setLang(lang){
    this.selectedLanguage = lang;
  }

  getLang(){
    return this.selectedLanguage;
  }

  setLangId(lang_id){
    this.selectedLanguageId = lang_id;
  }

  getLangId(){
    return this.selectedLanguageId;
  }

  getTableLanguage(){
    let lang = this.selectedLanguage || 'English';
    return Configuration.S3_BucketI18NURL+'i18n/'+lang+'.json'
  }

  getTranslationTour(){
    this.translate.get(['DASHBOARD_MENU_TITLE', 'DASHBOARD_MENU_CONTENT', 'SCORECARD_MENU', 'SCORECARD_MENU_CONTENT','LEADERBOARD_MENU', 'LEADERBOARD_MENU_CONTENT', 'TENDENCY_MENU', 'TENDENCY_MENU_CONTENT', 'CHANGE_LANG_TITLE',
      'CHANGE_LANG_CONTENT', 'MESSAGE_TITLE', 'MESSAGE_CONTENT', 'NOTIFICATION_TITLE', 'NOTIFICATION_CONTENT', 'HELP_TITLE', 'HELP_CONTENT', 'PROFILE_TITLE', 'PROFILE_CONTENT', 'COMMUNITY_LOGO_TITLE',
      'COMMUNITY_LOGO_CONTENT', 'MODULE_SEARCH_TITLE', 'MODULE_SEARCH_CONTENT', 'MODULES_TITLE', 'MODULES_CONTENT', 'RECENT_CERT_TITLE', 'RECENT_CERT_CONTENT', 'RECENT_MOD_T',
      'RECENT_MOD_C', 'NOT_CRI_C', 'MOD_SCORECARD_CONTENT', 'ACHIEVEMENT_T', 'ACHIEVEMENT_C', 'MODULE_NAME_T', 'MODULE_NAME_C', 'INSTRUCTIONAL_V_T', 'INSTRUCTIONAL_V_C','RESOURCE_V_T', 'RESOURCE_V_C',
      'CERT_T', 'CERT_C', 'AVAILABLE_LICENSE', 'SUBSCRIBE_LICENSE', 'AVA_LIC_C', 'SUB_LIC_C','LEADER_BOARD_TITLE','LEADER_BOARD_CONTENT','TENDENCY_REPORT_TITLE','TENDENCY_REPORT_CONTENT',
      'FAUNDATION_GAMES_T','FAUNDATION_GAMES_C','INTERMEDIATE_GAMES_T','INTERMEDIATE_GAMES_C','ADVANCED_GAMES_T','ADVANCED_GAMES_C','TOTAL_SCORE_TITLE','TOTAL_SCORE_CONTENT',
      'JOURNEY_STAGE_TITLE','JOURNEY_STAGE_CONTENT', 'JOURNEY_STEP_ICON_TITLE', 'JOURNEY_STEP_ICON_CONTENT', 'JOURNEY_TIMEFRAMES_TITLE', 'JOURNEY_TIMEFRAMES_CONTENT',
      'JOURNEY_TOOLS_TITLE', 'JOURNEY_TOOLS_CONTENT', 'JOURNEY_INSIGHTS_TITLE', 'JOURNEY_INSIGHTS_CONTENT', 'JOURNEY_TARGETED_CAPABILITY_TITLE', 'JOURNEY_TARGETED_CAPABILITY_CONTENT',
      'JOURNEY_SKILLS_TITLE', 'JOURNEY_SKILLS_CONTENT', 'JOURNEY_SEARCH_TITLE', 'JOURNEY_SEARCH_CONTENT' ]).subscribe(label =>{
      this.tourTranslateObj = label;
      console.log("-----------------Translation Tour Label-------------------");
      console.log(this.tourTranslateObj);
    });
  }

  getTranslationTourHome(){
    this.translate.get(['TRANSLATION_TITLE','TRANSLATION_CONTENT','USERNAME_TITLE','USERNAME_CONTENT','PASSWORD_TITLE','PASSWORD_CONTENT','FREE_GAME_TITLE','FREE_GAME_CONTENT',
    'LOGIN_PAGE_TITLE','LOGIN_PAGE_CONTENT','REGISTER_TITLE','REGISTER_CONTENT','FORGOT_PASSWORD_TITLE','FORGOT_PASSWORD_CONTENT','PRIVACY_POLICY_TITLE','PRIVACY_POLICY_CONTENT','TERMSOFUSE_TITLE','TERMSOFUSE_CONTENT']).subscribe(label =>{
      this.tourTranslateObj = label;
      console.log("-----------------Home Translation Tour Label-------------------");
      console.log(this.tourTranslateObj);
    });
  }

  getRespectiveTourData(screen_id){

    if(screen_id == 'LEARNER_DASHBOARD'){
        this.stepArr = [
          //header tour obj
          {
            element: "#learnerDashboardTour",
            title: this.tourTranslateObj.DASHBOARD_MENU_TITLE,
            content: this.tourTranslateObj.DASHBOARD_MENU_CONTENT,
            placement: 'bottom',
            backdrop: true,
          },
          {
            element: "#scorecardTour",
            title: this.tourTranslateObj.SCORECARD_MENU,
            content: this.tourTranslateObj.SCORECARD_MENU_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#tendencyReportTour",
            title: this.tourTranslateObj.TENDENCY_MENU,
            content: this.tourTranslateObj.TENDENCY_MENU_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#leaderBoardTour",
            title: this.tourTranslateObj.LEADERBOARD_MENU,
            content: this.tourTranslateObj.LEADERBOARD_MENU_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#totalScoreTour",
            title: this.tourTranslateObj.TOTAL_SCORE_TITLE,
            content: this.tourTranslateObj.TOTAL_SCORE_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#languageTour",
            title: this.tourTranslateObj.CHANGE_LANG_TITLE,
            content: this.tourTranslateObj.CHANGE_LANG_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#messageTour",
            title: this.tourTranslateObj.MESSAGE_TITLE,
            content: this.tourTranslateObj.MESSAGE_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#notificationTour",
            title: this.tourTranslateObj.NOTIFICATION_TITLE,
            content: this.tourTranslateObj.NOTIFICATION_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#helpTour",
            title: this.tourTranslateObj.HELP_TITLE,
            content: this.tourTranslateObj.HELP_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#profileTour",
            title: this.tourTranslateObj.PROFILE_TITLE,
            content: this.tourTranslateObj.PROFILE_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#logoTour",
            title: this.tourTranslateObj.COMMUNITY_LOGO_TITLE,
            content: this.tourTranslateObj.COMMUNITY_LOGO_CONTENT,
            placement: 'left',
          },
          //learner dashboard tour obj
          {
            element: "#moduleSearchTour",
            title: this.tourTranslateObj.MODULE_SEARCH_TITLE,
            content: this.tourTranslateObj.MODULE_SEARCH_CONTENT,
            placement: 'bottom',
          },
          {
            element: ".moduleBoxTour1",
            title: this.tourTranslateObj.MODULES_TITLE,
            content: this.tourTranslateObj.MODULES_CONTENT,
            placement: 'top',
          },
          {
            element: "#latestCertificateTour",
            title: this.tourTranslateObj.RECENT_CERT_TITLE,
            content: this.tourTranslateObj.RECENT_CERT_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#latestCourseTour",
            title: this.tourTranslateObj.RECENT_MOD_T,
            content: this.tourTranslateObj.RECENT_MOD_C,
            placement: 'bottom',
          },
          {
            element: "#criticleNotificationsTour",
            title: this.tourTranslateObj.NOTIFICATION_TITLE,
            content: this.tourTranslateObj.NOT_CRI_C,
            placement: 'left',
          }
        ];
      return this.stepArr;
    } else if(screen_id == 'HEADER'){

      this.stepArr = [
        {
          element: "#learnerDashboardTour",
          title: this.tourTranslateObj.DASHBOARD_MENU_TITLE,
          content: this.tourTranslateObj.DASHBOARD_MENU_CONTENT,
          placement: 'bottom',
          backdrop: true,
        },
        {
          element: "#scorecardTour",
          title: this.tourTranslateObj.SCORECARD_MENU,
          content: this.tourTranslateObj.SCORECARD_MENU_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#tendencyReportTour",
          title: this.tourTranslateObj.TENDENCY_MENU,
          content: this.tourTranslateObj.TENDENCY_MENU_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#leaderBoardTour",
          title: this.tourTranslateObj.LEADERBOARD_MENU,
          content: this.tourTranslateObj.LEADERBOARD_MENU_CONTENT,
          placement: 'bottom',
        },{
          element: "#totalScoreTour",
          title: this.tourTranslateObj.TOTAL_SCORE_TITLE,
          content: this.tourTranslateObj.TOTAL_SCORE_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#languageTour",
          title: this.tourTranslateObj.CHANGE_LANG_TITLE,
          content: this.tourTranslateObj.CHANGE_LANG_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#messageTour",
          title: this.tourTranslateObj.MESSAGE_TITLE,
          content: this.tourTranslateObj.MESSAGE_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#notificationTour",
          title: this.tourTranslateObj.NOTIFICATION_TITLE,
          content: this.tourTranslateObj.NOTIFICATION_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#profileTour",
          title: this.tourTranslateObj.PROFILE_TITLE,
          content: this.tourTranslateObj.PROFILE_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#logoTour",
          title: this.tourTranslateObj.COMMUNITY_LOGO_TITLE,
          content: this.tourTranslateObj.COMMUNITY_LOGO_CONTENT,
          placement: 'left',
        }
      ];

      return this.stepArr;
    } else if(screen_id == 'SCORECARD'){
      this.stepArr = [
         {
           element: "#courseNameAccordion",
           title: this.tourTranslateObj.MODULES_TITLE,
           content: this.tourTranslateObj.MOD_SCORECARD_CONTENT,
           placement: 'right'
         },
         {
          element: '#earnedCertificateSection',
          title: this.tourTranslateObj.ACHIEVEMENT_T,
          content:this.tourTranslateObj.ACHIEVEMENT_C,
          placement:"left"
         }
         ];

       return this.stepArr;
    } else if(screen_id == 'MODULE_DETAILS'){
        this.stepArr = [
          {
            element: "#learnerDashboardTour",
            title: this.tourTranslateObj.DASHBOARD_MENU_TITLE,
            content: this.tourTranslateObj.DASHBOARD_MENU_CONTENT,
            placement: 'bottom',
            backdrop: true,
          },
          {
            element: "#scorecardTour",
            title: this.tourTranslateObj.SCORECARD_MENU,
            content: this.tourTranslateObj.SCORECARD_MENU_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#tendencyReportTour",
            title: this.tourTranslateObj.TENDENCY_MENU,
            content: this.tourTranslateObj.TENDENCY_MENU_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#leaderBoardTour",
            title: this.tourTranslateObj.LEADERBOARD_MENU,
            content: this.tourTranslateObj.LEADERBOARD_MENU_CONTENT,
            placement: 'bottom',
          },{
            element: "#totalScoreTour",
            title: this.tourTranslateObj.TOTAL_SCORE_TITLE,
            content: this.tourTranslateObj.TOTAL_SCORE_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#languageTour",
            title: this.tourTranslateObj.CHANGE_LANG_TITLE,
            content: this.tourTranslateObj.CHANGE_LANG_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#messageTour",
            title: this.tourTranslateObj.MESSAGE_TITLE,
            content: this.tourTranslateObj.MESSAGE_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#notificationTour",
            title: this.tourTranslateObj.NOTIFICATION_TITLE,
            content: this.tourTranslateObj.NOTIFICATION_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#profileTour",
            title: this.tourTranslateObj.PROFILE_TITLE,
            content: this.tourTranslateObj.PROFILE_CONTENT,
            placement: 'bottom',
          },
          {
            element: "#logoTour",
            title: this.tourTranslateObj.COMMUNITY_LOGO_TITLE,
            content: this.tourTranslateObj.COMMUNITY_LOGO_CONTENT,
            placement: 'left',
          },
          /*{
            element: "#course_name",
            title: this.tourTranslateObj.MODULE_NAME_T,
            content: this.tourTranslateObj.MODULE_NAME_C,
            placement: 'bottom',
            backdrop: true,
          },*/
          {
            element: ".levelTour1",
            title: this.tourTranslateObj.FAUNDATION_GAMES_T,
            content: this.tourTranslateObj.FAUNDATION_GAMES_C,
            placement: 'bottom',
          },{
            element: ".levelTour2",
            title: this.tourTranslateObj.INTERMEDIATE_GAMES_T,
            content: this.tourTranslateObj.INTERMEDIATE_GAMES_C,
            placement: 'bottom',
          },{
            element: ".levelTour3",
            title: this.tourTranslateObj.ADVANCED_GAMES_T,
            content: this.tourTranslateObj.ADVANCED_GAMES_C,
            placement: 'bottom',
          },
          {
            element: "#instructionalTourTab",
            title: this.tourTranslateObj.INSTRUCTIONAL_V_T,
            content: this.tourTranslateObj.INSTRUCTIONAL_V_C,
            placement: 'bottom',
          },
          {
            element: "#certificationTourTab",
            title: this.tourTranslateObj.CERT_T,
            content: this.tourTranslateObj.CERT_C,
            placement: 'bottom',
          },
          {
            element: "#resourceTourTab",
            title: this.tourTranslateObj.RESOURCE_V_T,
            content: this.tourTranslateObj.RESOURCE_V_C,
            placement: 'bottom',
          }
        ];

      return this.stepArr;
    } else if(screen_id == 'LICENSE_SUBSCRIPTION'){
      this.stepArr = [
          {
            element: "#subscribedLicense",
            title: this.tourTranslateObj.SUBSCRIBE_LICENSE,
            content: this.tourTranslateObj.SUB_LIC_C,
            placement: 'top',
          },
          {
            element: "#availableLicense",
            title: this.tourTranslateObj.AVAILABLE_LICENSE,
            content: this.tourTranslateObj.AVA_LIC_C,
            placement: 'top',
          }
        ];

      return this.stepArr;
    }else if(screen_id == 'LEADER_BOARD'){
      this.stepArr = [
          {
            element: "#leaderboardTour",
            title: this.tourTranslateObj.LEADER_BOARD_TITLE,
            content: this.tourTranslateObj.LEADER_BOARD_CONTENT,
            placement: 'top',
          }
        ];

      return this.stepArr;
    }else if(screen_id == 'TENDENCY_REPORT'){
      this.stepArr = [
          {
            element: "#tendencyTour",
            title: this.tourTranslateObj.TENDENCY_REPORT_TITLE,
            content: this.tourTranslateObj.TENDENCY_REPORT_CONTENT,
            placement: 'top',
          }
        ];

      return this.stepArr;
    }else if(screen_id == 'LOGIN_PAGE'){
      this.stepArr = [
          {
            element: "#translationDropdown",
            title: this.tourTranslateObj.TRANSLATION_TITLE,
            content: this.tourTranslateObj.TRANSLATION_CONTENT,
            placement: 'bottom',
          },{
            element: "#userNameTour",
            title: this.tourTranslateObj.USERNAME_TITLE,
            content: this.tourTranslateObj.USERNAME_CONTENT,
            placement: 'bottom',
          },{
            element: "#passwordTour",
            title: this.tourTranslateObj.PASSWORD_TITLE,
            content: this.tourTranslateObj.PASSWORD_CONTENT,
            placement: 'bottom',
          },{
            element: "#forgotPasswordTour",
            title: this.tourTranslateObj.FORGOT_PASSWORD_TITLE,
            content: this.tourTranslateObj.FORGOT_PASSWORD_CONTENT,
            placement: 'bottom',
          },{
            element: "#loginbtnTour",
            title: this.tourTranslateObj.LOGIN_PAGE_TITLE,
            content: this.tourTranslateObj.LOGIN_PAGE_CONTENT,
            placement: 'top',
          },{
            element: "#registerbtnTour",
            title: this.tourTranslateObj.REGISTER_TITLE,
            content: this.tourTranslateObj.REGISTER_CONTENT,
            placement: 'top',
          },{
            element: "#freeGameTour",
            title: this.tourTranslateObj.FREE_GAME_TITLE,
            content: this.tourTranslateObj.FREE_GAME_CONTENT,
            placement: 'top',
          },{
            element: "#privacyPolicyTour",
            title: this.tourTranslateObj.PRIVACY_POLICY_TITLE,
            content: this.tourTranslateObj.PRIVACY_POLICY_CONTENT,
            placement: 'top',
          },{
            element: "#termsOfUseTour",
            title: this.tourTranslateObj.TERMSOFUSE_TITLE,
            content: this.tourTranslateObj.TERMSOFUSE_CONTENT,
            placement: 'top',
          }
        ];
      return this.stepArr;
    }else if(screen_id == 'JOURNEY_DETAILS'){
      this.stepArr = [
        {
          element: "#learnerDashboardTour",
          title: this.tourTranslateObj.DASHBOARD_MENU_TITLE,
          content: this.tourTranslateObj.DASHBOARD_MENU_CONTENT,
          placement: 'bottom',
          backdrop: true,
        },
        {
          element: "#scorecardTour",
          title: this.tourTranslateObj.SCORECARD_MENU,
          content: this.tourTranslateObj.SCORECARD_MENU_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#tendencyReportTour",
          title: this.tourTranslateObj.TENDENCY_MENU,
          content: this.tourTranslateObj.TENDENCY_MENU_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#leaderBoardTour",
          title: this.tourTranslateObj.LEADERBOARD_MENU,
          content: this.tourTranslateObj.LEADERBOARD_MENU_CONTENT,
          placement: 'bottom',
        },{
          element: "#totalScoreTour",
          title: this.tourTranslateObj.TOTAL_SCORE_TITLE,
          content: this.tourTranslateObj.TOTAL_SCORE_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#languageTour",
          title: this.tourTranslateObj.CHANGE_LANG_TITLE,
          content: this.tourTranslateObj.CHANGE_LANG_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#messageTour",
          title: this.tourTranslateObj.MESSAGE_TITLE,
          content: this.tourTranslateObj.MESSAGE_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#notificationTour",
          title: this.tourTranslateObj.NOTIFICATION_TITLE,
          content: this.tourTranslateObj.NOTIFICATION_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#profileTour",
          title: this.tourTranslateObj.PROFILE_TITLE,
          content: this.tourTranslateObj.PROFILE_CONTENT,
          placement: 'bottom',
        },
        {
          element: "#logoTour",
          title: this.tourTranslateObj.COMMUNITY_LOGO_TITLE,
          content: this.tourTranslateObj.COMMUNITY_LOGO_CONTENT,
          placement: 'left',
        },
        {
          element: "#journeySearchTour",
          title: this.tourTranslateObj.JOURNEY_SEARCH_TITLE,
          content: this.tourTranslateObj.JOURNEY_SEARCH_CONTENT,
          placement: 'auto',
        },
        {
          element: "#journeyStageTour",
          title: this.tourTranslateObj.JOURNEY_STAGE_TITLE,
          content: this.tourTranslateObj.JOURNEY_STAGE_CONTENT,
          placement: 'auto',
        },
        {
          element: "#stepIconTour",
          title: this.tourTranslateObj.JOURNEY_STEP_ICON_TITLE,
          content: this.tourTranslateObj.JOURNEY_STEP_ICON_CONTENT,
          placement: 'auto',
        },
        {
          element: "#timeFramesTour",
          title: this.tourTranslateObj.JOURNEY_TIMEFRAMES_TITLE,
          content: this.tourTranslateObj.JOURNEY_TIMEFRAMES_CONTENT,
          placement: 'auto',
        },
        {
          element: "#toolsTour",
          title: this.tourTranslateObj.JOURNEY_TOOLS_TITLE,
          content: this.tourTranslateObj.JOURNEY_TOOLS_CONTENT,
          placement: 'auto',
        },
        {
          element: "#insightsTour",
          title: this.tourTranslateObj.JOURNEY_INSIGHTS_TITLE,
          content: this.tourTranslateObj.JOURNEY_INSIGHTS_CONTENT,
          placement: 'auto',
        },
        {
          element: "#targetedCapabilityTour",
          title: this.tourTranslateObj.JOURNEY_TARGETED_CAPABILITY_TITLE,
          content: this.tourTranslateObj.JOURNEY_TARGETED_CAPABILITY_CONTENT,
          placement: 'auto',
        },
        {
          element: "#relatedSkillsTour",
          title: this.tourTranslateObj.JOURNEY_SKILLS_TITLE,
          content: this.tourTranslateObj.JOURNEY_SKILLS_CONTENT,
          placement: 'auto',
        }
      ];

      return this.stepArr;
    }
  }

  saveUsersLoginDetails(details){
    return this.http.post(Configuration.ServerWithApiUrl+'/saveUsersLoginDetails',details)
      .map((res: any)=>res)
  }

  saveUsersGamePlayDetails(details){
    return this.http.post(Configuration.ServerWithApiUrl+'/saveUsersGamePlayDetails',details)
      .map((res: any)=>res)
  }

  saveUsersGameSpriteImgsFailedToLoad(details){
    return this.http.post(Configuration.ServerWithApiUrl+'/saveUsersGameSpriteImgsFailedToLoad',details)
      .map((res: any)=>res)
  }

  getCurrentBrowserName() {
    if (navigator.userAgent.match(new RegExp('\\Edge\\b'))) {
      return "Edge";
    }
    else if (navigator.userAgent.match(new RegExp('\\Opera\\b')) || navigator.userAgent.match(new RegExp('\\OPR\\b'))) {
      return 'Opera';
    }
    else if (navigator.userAgent.match(new RegExp('\\Chrome\\b'))) {
      return "Chrome";
    }
    else if (navigator.userAgent.match(new RegExp('\\Safari\\b'))) {
      return "Safari";
    }
    else if (navigator.userAgent.match(new RegExp('\\Firefox\\b'))) {
      return "Firefox";
    }
    else if (navigator.userAgent.match(new RegExp('\\MSIE\\b'))) {
      return "IE";
    } else if (navigator.userAgent.match(new RegExp('\\Edg\\b'))) {
      return "Chromium";
    }
    else {
      return "Un-known";
    }
  }

  getCurrentScreenResolution() {
    return window.screen.width * window.devicePixelRatio + "X" + window.screen.height * window.devicePixelRatio;
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/global.service.ts